import { render, staticRenderFns } from "./Agencies.vue?vue&type=template&id=39779b90"
import script from "./Agencies.vue?vue&type=script&lang=ts"
export * from "./Agencies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports